module.exports = __webpack_public_path__ + "img/phone_bg.416a7f12.png";